import src from "IMAGE";
export default { src, width: 1200, height: 442, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAPElEQVR42mXKOQ6AMAwEwPz/sbF8yIWvRSABRYrpZpkZblWFmTksVcXeG8yMN7s7MhPd/Qci+ogIIuJJFxW0XS73l7aNAAAAAElFTkSuQmCC"};
